export const getSharedWorkOrder = (workOrderId) =>
    fetch(`${process.env.REACT_APP_API_URL}/api/v1/work-orders/${workOrderId}?includes=`)
        .then(resp => resp.json())
        .then(resp => resp.result)
        .catch(console.error);


export const addComment = (workOrderId, data) =>
    fetch(`${process.env.REACT_APP_API_URL}/api/v1/public/workorders/share/${workOrderId}/messages`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
    })
        .then(resp => resp.json());
